import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import LegacyPratusTable, {
  LegacySelectRowConfig,
} from 'components/DesignSystems/PratusTable/LegacyPratusTable';
export default function CalendarEventAddAttendeeDialog({
  incidentRoster,
  incidentMembersToAttend,
  setIncidentMembersToAttend,
  onClose,
}: {
  incidentRoster: any[];
  incidentMembersToAttend: string[];
  setIncidentMembersToAttend: any;
  onClose: any;
}) {
  const [selectedMembers, setSelectedMembers] = useState(
    incidentRoster.filter((member) =>
      incidentMembersToAttend.includes(member.user_guid)
    )
  );

  const allColumn = [
    {
      dataField: 'email_address',
      text: 'Email Address',
      sort: true,
      headerAttrs: { title: 'Sort By:' },
      attrs: { title: 'Member Email' },
    },
    {
      dataField: 'user_name',
      text: 'Member Name',
      sort: true,
      attrs: { title: 'Member Name' },
    },
    {
      dataField: 'incident_seat',
      text: 'Incident Seat',
      sort: true,
      attrs: { title: 'Incident Seat' },
    },
  ];

  const selectRow: LegacySelectRowConfig = {
    mode: 'checkbox',
    clickToSelect: true,
    hideSelectAll: false,
    selected: selectedMembers.map((item) => item.user_guid),
    onSelect: (row: any) => {
      let selection = selectedMembers.map((i) => i.user_guid);
      if (selection.includes(row.user_guid)) {
        selection = selection.filter((i) => i !== row.user_guid);
      } else {
        selection.push(row.user_guid);
      }
      setSelectedMembers(
        incidentRoster.filter((item) => selection.includes(item.user_guid))
      );
    },
    onSelectAll: (_isSelect: boolean, rows: any) => {
      let selection = selectedMembers.map((i) => i.user_guid);
      rows.forEach((row: any) => {
        if (selection.includes(row.user_guid)) {
          selection = selection.filter((i) => i !== row.user_guid);
        } else {
          selection.push(row.user_guid);
        }
      });
      setSelectedMembers(
        incidentRoster.filter((item) => selection.includes(item.user_guid))
      );
    },
  };

  const onAddMembersClick = () => {
    setIncidentMembersToAttend(
      selectedMembers.map((member: any) => member.user_guid)
    );

    onClose();
  };

  return (
    <Modal
      show={true}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>Add New Attendees</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5>Select Incident Members</h5>
        <LegacyPratusTable
          keyField={'user_guid'}
          rows={incidentRoster}
          columns={allColumn}
          selectRow={selectRow}
          hasPagination={true}
          paginationPerPageItem={10}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="button-group">
          <StylishNewButton
            type="button"
            className="button--primary"
            onClick={onAddMembersClick}
          >
            Add Attendees
          </StylishNewButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
